import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration from your .env.local file
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'test',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'test',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'test',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'test',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || 'test',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || 'test',
};

// Initialize Firebase only outside of test runs
let app;
if (process.env.NODE_ENV !== 'test') {
  if (!getApps().length) {
    app = initializeApp(firebaseConfig);
  } else {
    app = getApps()[0];
  }
}

// Export services for use in other parts of the app
export const auth = getAuth(app);
export const db = getFirestore(app);